import { useTranslation } from "react-i18next";

import { LoadingSpinner } from "@/shared/components/ui/loading-spinner";
import { useIsAdmin } from "@/shared/hooks/use-admin-validation";
import { useIsSuperAdminRole } from "@/shared/hooks/use-system-role";
import { useViewScope } from "@/shared/hooks/use-view-scope";
import { MemoryPanel } from "./MemoryPanel";

/**
 * Memory no My view e na visão da organização (AB#87149). O nível sai da navegação,
 * como nas Skills; a Memory do workspace vive na aba do Brain.
 */
export const MemoryPage = () => {
  const { t } = useTranslation();
  const { scope, isResolving } = useViewScope();
  const { isAdmin } = useIsAdmin();
  const { isSuperAdmin } = useIsSuperAdminRole();

  if (isResolving) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (scope === "user") {
    // No próprio espaço a pessoa manda: grava e esquece sem depender de papel.
    return <MemoryPanel target={{ scope: "user" }} canCreate />;
  }

  if (scope === "organization") {
    return <MemoryPanel target={{ scope: "organization" }} canCreate={isAdmin || isSuperAdmin} />;
  }

  return (
    <div className="flex min-h-[400px] items-center justify-center text-muted-foreground">
      {t("memory.selectOrganization")}
    </div>
  );
};

export default MemoryPage;
